import React from "react";

const SuccessMessageDisplay = ({ successMessage }) => {
    return (
        successMessage && (
            <div className="upsell-success-message mt-3">
                <div className="alert alert-success text-left" role="alert" >
                    <a className="close link-primary cursor-pointer" data-bs-dismiss="alert" aria-label="close" >
                        &times;
                    </a>
                    {successMessage}
                </div>
            </div>
        )
    );
};

export default SuccessMessageDisplay;
